export default __webpack_public_path__ + "static/fall1 (1)-219ffd708872f31a6a40737568e98ce3.jpeg";